<script lang="ts" setup>
import {onMounted} from 'vue';
import LoginForm from "@src/components/views/AccessView/LoginForm.vue";
import Cover from "@src/components/views/AccessView/Cover.vue";

onMounted(async () => {
    // await Promise.all([
    //     db.sessions.clear(),
    //     db.messages.clear(),
    //     db.departments.clear(),
    //     db.channels.clear(),
    //     db.kanbans.clear(),
    //     db.contacts.clear(),
    //     db.vcards.clear(),
    //     db.tags.clear(),
    //     db.template_messages.clear(),
    //     db.locations.clear(),
    //     db.groups.clear(),
    //     db.group_messages.clear(),
    // ]);
});
</script>

<template>
    <div class="w-full h-full">
        <div class="w-full h-full flex dark:bg-gray-800 overflow-hidden">
            <Cover/>
            <LoginForm/>
        </div>
    </div>
</template>

